import { makeItem } from "../Item";

export const SunlightStone = makeItem(20014, "Sunlight Stone", "item");
export const EternitySand = makeItem(215, "Eternity Sand", "item");
export const DamascusCrystal = makeItem(203, "Damascus Crystal", "item");